export default __webpack_public_path__ + "static/media/image 3 no buttons.959ca236.png";